import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Divider,
  DatePicker,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  fxRateSetupAPI,
  fxRateSetupLabel,
  fxRateSetupStatic,
} from "../ManageFxRate.config";
import appStatic from "../../../../config/appStatic";

const { Text, Title } = Typography;

const EditPRD0602 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { monthList } = appStatic;

  const dispatch = useDispatch();
  const [rateTypes, setRateTypes] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [active, setActive] = useState(false);
  const [status, setStatus] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState({});

  useEffect(() => {
    getRateTypeTemplate();
    getCurrencyTemplate();
    setIsLoading(false);
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${fxRateSetupAPI.FxRates}/${state.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setDate(objDetail);

        // SHOW THE SAVED DATA
        useForm.setFieldsValue({
          fromCurrency: objDetail.fromCurrencyData.code,
          toCurrency: objDetail.toCurrencyData.code,
          conversionType: objDetail.conversionType,
          conversionCurrency: objDetail?.conversionCurrencyData?.code
            ? objDetail?.conversionCurrencyData?.code
            : "-",
          //   date: objDetail?.date ? (`${objDetail?.date[2]} ${monthList[objDetail?.date[1] - 1]} ${objDetail?.date[0]}`)
          //   : "-",
          rateType: objDetail.rateType,
          midRate: objDetail.midRate,
          buyRate: objDetail.buyRate,
          saleRate: objDetail.saleRate,
          saleSpread: objDetail.saleSpread,
          buySpread: objDetail.buySpread,
        });

        setActive(objDetail?.active);
        setStatus(objDetail?.recordStatus);
        setIsLoading(false);
      }
    });
  };
  function getRateTypeTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, fxRateSetupAPI.FxRateTypes, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempRateTypes = [];

        objList?.forEach((element) => {
          tempRateTypes.push({
            value: element.code,
            label: element.name,
          });
        });

        setRateTypes(tempRateTypes);
      }
    });
  }

  function getCurrencyTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, fxRateSetupAPI.Currencies, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrencies = [];

        objList?.currencyOptions?.forEach((element) => {
          tempCurrencies.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setCurrencies(tempCurrencies);
      }
    });
  }

  function onCancel() {
    navigate("/prd0602", { replace: false });
  }

  const onSubmit = (formValues) => {
    const url = `${fxRateSetupAPI.FxRates}/${state.key}`;

    formValues.date = BOM.DateTime(formValues.date, "only-date");
    formValues.active = active;
    formValues.status = status;

    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, fxRateSetupLabel.editFXRate);
        navigate("/prd0602");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={fxRateSetupLabel.editFxRate}
        pageItems={fxRateSetupStatic.editFxRateItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {fxRateSetupLabel.fxRateSetUp}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.rateDate}
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.rateDate),
                    },
                  ]}
                >
                  <DatePicker
                    placeholder={
                      date?.date
                        ? `${date?.date[2]} ${monthList[date?.date[1] - 1]} ${
                            date?.date[0]
                          }`
                        : "-"
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.currencyCode1}
                  name="fromCurrency"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.currencyCode1),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.currencyCode1} *`,
                      "select"
                    )}
                    options={currencies}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.currencyCode2}
                  name="toCurrency"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.currencyCode2),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.currencyCode2} *`,
                      "select"
                    )}
                    options={currencies}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.conversionType}
                  name="conversionType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.conversionType),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.conversionType
                    )}
                    options={[
                      { id: 1, label: "Direct", value: "D" },
                      { id: 2, label: "InDirect", value: "I" },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.conversionCurrency}
                  name="conversionCurrency"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.conversionCurrency}`,
                      "select"
                    )}
                    options={currencies}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={fxRateSetupLabel.rateType} name="rateType">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.rateType}`,
                      "select"
                    )}
                    options={rateTypes}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.midRate}
                  name="midRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.midRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.midRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.buyRate}
                  name="buyRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.buyRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.buyRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.saleRate}
                  name="saleRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.saleRate),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.saleRate
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.buySpread}
                  name="buySpread"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.buySpread),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.buySpread
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={fxRateSetupLabel.saleSpread}
                  name="saleSpread"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(fxRateSetupLabel.saleSpread),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      fxRateSetupLabel.saleSpread
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={fxRateSetupLabel.authStatus} name="status">
                  <Checkbox
                    placeholder={BOM.handlePlaceholderMsg(
                      `${fxRateSetupLabel.authStatus} *`,
                      "select"
                    )}
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={fxRateSetupLabel.active} name="active">
                  <Checkbox checked={active} disabled />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_FX_RATE") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(EditPRD0602);
